import type {
    SxProps,
    Theme
} from '@mui/material/styles';

const styles = {
    container: (theme) => ({
        borderBottom: `1px solid ${theme.colors.mercury}`
    }),

    freeSpace: {
        flex: 1
    },

    headerContainer: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        gap: {
            mobileSmall: 2,
            xs: 0.5
        },
        height: {
            md: 120,
            xs: 85
        },
        justifyContent: 'space-between',
        px: {
            md: 3,
            mobileSmall: 2,
            xs: 1
        },
        width: '100%'
    },

    landingPageHeader: {
        height: {
            md: 160,
            xs: 85
        }
    },

    menuButton: (theme) => ({
        backgroundColor: 'transparent',
        borderColor: theme.colors.secondaryDark,
        color: theme.colors.secondaryDark,
        px: {
            md: '16px !important',
            xs: '8px !important'
        },
        whiteSpace: 'nowrap'
    }),

    menuDivider: {
        borderBottom: '1px solid',
        borderColor: 'divider',
        minHeight: 0,
        mx: 2,
        padding: '0 !important',
        width: 'auto'
    },

    mobileNav: (theme) => ({
        borderTopColor: theme.colors.mercury,
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        boxSizing: 'inherit',
        pb: 4,
        pt: 3,
        px: {
            mobileLarge: 3,
            mobileSmall: 1.75,
            xs: 1
        },
        width: '100%'
    }),

    navBar: {
        boxSizing: 'border-box',
        width: '100%'
    },

    navLink: (theme) => ({
        '&::before': {
            backgroundColor: theme.colors.steelGray,
            borderRadius: 1,
            bottom: -8,
            content: '""',
            height: 2.5,
            left: '10%',
            opacity: 0,
            position: 'absolute',
            transition: 'opacity .1s ease-in',
            width: '80%'
        },
        '&:focus-visible': {
            '@media (forced-colors: active)': {
                outlineColor: 'Highlight'
            },
            outline: `2px solid ${theme.colors.teal}`,
            outlineOffset: 4
        },

        '&:hover, &:focus-visible': {
            '&::before': {
                opacity: 1
            },

            backgroundColor: 'transparent',
            textDecoration: 'none !important'
        },

        '&[aria-current="page"]': {
            '&::before': {
                opacity: 1
            },

            fontWeight: 600
        },

        color: `${theme.colors.steelGray} !important`,
        fontFamily: `${theme.typography.fontFamily} !important`,
        fontSize: {
            md: '18px !important',
            xs: '16px !important'
        },
        lineHeight: {
            md: '24px !important',
            xs: '20px !important'
        },
        p: 0,
        position: 'relative',
        textAlign: 'center',
        textTransform: 'capitalize'
    }),

    navLinkActive: {
        '&::before': {
            opacity: 1
        },

        fontWeight: 600
    },

    navLinkContainer: (theme) => ({
        display: 'flex',
        gap: {
            mobileLarge: 3,
            mobileSmall: 2,
            xs: 1.5
        },
        justifyContent: 'center',

        [theme.breakpoints.down('md')]: {
            mx: 'auto'
        }
    }),

    popover: (theme) => ({
        '& .MuiListItemButton-root': {
            gap: 2
        },

        '& .MuiListItemIcon-root': {
            minWidth: 0
        },

        '& .MuiPopover-paper': {
            borderColor: theme.colors.steelGray,
            borderRadius: {
                md: '25px',
                xs: '15px'
            },
            borderStyle: 'solid',
            borderWidth: '1px',
            mt: 2
        },

        color: theme.colors.steelGray,
        fontSize: 16,
        lineHeight: 25
    }),

    roundButton: {
        '& span': {
            margin: 0
        },

        alignItems: 'center',
        borderRadius: '50%',
        display: 'flex',
        height: 44,
        justifyContent: 'center',
        minWidth: 44,
        p: 0,
        width: 44
    },

    roundSearchButton: (theme) => ({
        backgroundColor: theme.colors.plantation,
        color: theme.colors.white
    }),

    tabletNav: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        pb: 3,
        pt: 0,
        px: 3
    }
} satisfies Record<string, SxProps<Theme>>;

export default styles;
